"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _stream = require("../../../actions/stream");
var _actionUtils = require("../../../utils/actionUtils");
function streamToggled(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var attendeeId = _ref2.attendeeId;
  if (!(0, _actionUtils.isSameAttendee)(attendeeId, getState())) {
    dispatch((0, _stream.syncEndpoints)());
  }
}
var _default = exports["default"] = streamToggled;